// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

// @flow
import { all, call, fork, put, select, takeEvery } from 'redux-saga/effects'

import { changeSidebarType as changeSidebarTypeAction, changeTopbarTheme as changeTopbarThemeAction } from './actions'
import {
  CHANGE_LAYOUT,
  CHANGE_LAYOUT_WIDTH,
  CHANGE_SIDEBAR_THEME,
  CHANGE_SIDEBAR_THEME_IMAGE,
  CHANGE_SIDEBAR_TYPE,
  CHANGE_TOPBAR_THEME,
  SET_IS_LOAD_CATALOGOS,
  SHOW_RIGHT_SIDEBAR,
  SET_IS_AUTHENTICATED,
} from './actionTypes'

import {
  CATALOGOS_SET_ESTADO,
  CATALOGOS_SET_ID_LISTA_SELECCION,
  CATALOGOS_SET_ID_NOMBRE,
  CATALOGOS_SET_LISTASELECCION,
  CATALOGOS_SET_LISTASELECCION_AGRUPACIONES,
  CATALOGOS_SET_LISTASELECCION_DATA,
  CATALOGOS_SET_LS_TREE,
  CATALOGOS_SET_RESERVAS_WIZZARD,
} from '../catalogos/CatalogosTypes'

import { RootState } from '../store'

import { notifications } from '@/common/helpers/notifications'
import { getAllListaSeleccion, getEstados, getReservasWizzard } from '@/common/helpers/odataApiServices'
import {
  agruparCatalogos,
  agruparListaSeleccionPorTabla,
  buildListaSeleccionTree,
  idListaSeleccion,
  idNombre,
} from '@/common/helpers/utils'
import { getRuntimeConfig } from '@/core/config/runtimeConfig'

/**
 * Changes the body attribute
 */
function changeBodyAttribute(attribute: any, value: any): any {
  if (document.body) {
    document.body.setAttribute(attribute, value)
  }

  return true
}

/**
 * Toggle the class on body
 * @param {*} cssClass
 */
function manageBodyClass(cssClass: any, action = 'toggle'): any {
  switch (action) {
    case 'add':
      if (document.body) {
        document.body.classList.add(cssClass)
      }
      break

    case 'remove':
      if (document.body) {
        document.body.classList.remove(cssClass)
      }
      break

    default:
      if (document.body) {
        document.body.classList.toggle(cssClass)
      }
      break
  }

  return true
}

/**
 * Changes the Layout type
 * @param {*} param0
 */
function* changeLayout({ payload: layout }: any): Generator {
  try {
    if (getRuntimeConfig().IS_PRODUCTION) {
      yield put(changeTopbarThemeAction('dark'))
    } else {
      yield put(changeTopbarThemeAction('colored'))
    }

    document.body.removeAttribute('data-sidebar')
    document.body.removeAttribute('data-sidebar-image')
    document.body.removeAttribute('data-sidebar-size')

    yield call(changeBodyAttribute, 'data-Layout', layout)
  } catch {
    //
  }
}

/**
 * Changes the Layout width
 * @param {*} param0
 */
function* changeLayoutWidth({ payload: width }: any): Generator {
  try {
    if (width === 'boxed') {
      yield put(changeSidebarTypeAction('icon'))
      yield call(changeBodyAttribute, 'data-Layout-size', width)
      yield call(changeBodyAttribute, 'data-Layout-scrollable', false)
    } else if (width === 'scrollable') {
      yield put(changeSidebarTypeAction('default'))
      yield call(changeBodyAttribute, 'data-Layout-scrollable', true)
    } else {
      yield put(changeSidebarTypeAction('default'))
      yield call(changeBodyAttribute, 'data-Layout-size', width)
      yield call(changeBodyAttribute, 'data-Layout-scrollable', false)
    }
  } catch {
    //
  }
}

/**
 * Changes the left sidebar theme
 * @param {*} param0
 */
function* changeLeftSidebarTheme({ payload: theme }: any): Generator {
  try {
    yield call(changeBodyAttribute, 'data-sidebar', theme)
  } catch {
    //
  }
}

/**
 * Changes the left sidebar theme Image
 * @param {*} param0
 */
function* changeLeftSidebarThemeImage({ payload: theme }: any): Generator {
  try {
    yield call(changeBodyAttribute, 'data-sidebar-image', theme)
  } catch {
    //
  }
}

/**
 * Changes the topbar theme
 * @param {*} param0
 */
function* changeTopbarTheme({ payload: theme }: any): Generator {
  try {
    yield call(changeBodyAttribute, 'data-topbar', theme)
  } catch {
    //
  }
}

/**
 * Changes the left sidebar type
 * @param {*} param0
 */
function* changeLeftSidebarType({ payload: { sidebarType, isMobile } }: any): Generator {
  try {
    switch (sidebarType) {
      case 'compact':
        yield call(changeBodyAttribute, 'data-sidebar-size', 'small')
        yield call(manageBodyClass, 'sidebar-enable', 'remove')
        yield call(manageBodyClass, 'vertical-collpsed', 'remove')
        break

      case 'icon':
        yield call(changeBodyAttribute, 'data-sidebar-size', '')
        yield call(changeBodyAttribute, 'data-keep-enlarged', 'true')
        yield call(manageBodyClass, 'vertical-collpsed', 'add')
        break

      case 'condensed':
        yield call(manageBodyClass, 'sidebar-enable', 'add')
        if (window.screen.width >= 992) {
          yield call(manageBodyClass, 'vertical-collpsed', 'remove')
          yield call(manageBodyClass, 'sidebar-enable', 'remove')
          yield call(manageBodyClass, 'vertical-collpsed', 'add')
          yield call(manageBodyClass, 'sidebar-enable', 'add')
        } else {
          yield call(manageBodyClass, 'sidebar-enable', 'add')
          yield call(manageBodyClass, 'vertical-collpsed', 'add')
        }
        break

      default:
        yield call(changeBodyAttribute, 'data-sidebar-size', '')
        yield call(manageBodyClass, 'sidebar-enable', 'remove')
        if (!isMobile) {
          yield call(manageBodyClass, 'vertical-collpsed', 'remove')
        }
        break
    }
  } catch {
    //
  }
}

/**
 * Show the rightsidebar
 */
function* showRightSidebar(): Generator {
  try {
    yield call(manageBodyClass, 'right-bar-enabled', 'add')
  } catch {
    //
  }
}
/**
 * CARGA DE CATALOS EN SEGUNDO PLANO
 */

function* loadCatalogos(): any {
  const { isLoadCatalogos, isAuthenticated } = yield select((state: RootState) => state.Layout)

  if (!isLoadCatalogos && isAuthenticated) {
    try {
      const catalogoListaSeleccion = yield call(getAllListaSeleccion)
      const listasById = yield call(idListaSeleccion, catalogoListaSeleccion.value)

      yield put({
        type: CATALOGOS_SET_ID_LISTA_SELECCION,
        payload: listasById,
      })
      yield put({
        type: CATALOGOS_SET_LISTASELECCION_DATA,
        payload: catalogoListaSeleccion.value,
      })
      const listaSeleccionAgrupado = agruparCatalogos(catalogoListaSeleccion.value)

      yield put({
        type: CATALOGOS_SET_LISTASELECCION,
        payload: listaSeleccionAgrupado,
      })
      const listaSeleccionAgrupaciones = yield call(agruparListaSeleccionPorTabla, listaSeleccionAgrupado)

      yield put({
        type: CATALOGOS_SET_LISTASELECCION_AGRUPACIONES,
        payload: listaSeleccionAgrupaciones,
      })
      const listaTree = yield call(buildListaSeleccionTree, catalogoListaSeleccion.value)

      yield put({ type: CATALOGOS_SET_LS_TREE, payload: listaTree })
      const catalogoEstados = yield call(getEstados)
      const estadosAgrupado = agruparCatalogos(catalogoEstados.value)

      yield put({ type: CATALOGOS_SET_ESTADO, payload: estadosAgrupado })
      const reservasWizzard = yield call(getReservasWizzard, estadosAgrupado)

      yield put({
        type: CATALOGOS_SET_RESERVAS_WIZZARD,
        payload: reservasWizzard,
      })

      const idEstadoNombre = yield call(idNombre, catalogoEstados.value, reservasWizzard)

      yield put({
        type: CATALOGOS_SET_ID_NOMBRE,
        payload: idEstadoNombre,
      })
      yield put({ type: SET_IS_LOAD_CATALOGOS, payload: true })
    } catch (error) {
      notifications({ ex: error })
    }
  }
}

/**
 * Watchers
 */
export function* watchChangeLayoutType(): Generator {
  yield takeEvery(CHANGE_LAYOUT, changeLayout)
}

export function* watchChangeLayoutWidth(): Generator {
  yield takeEvery(CHANGE_LAYOUT_WIDTH, changeLayoutWidth)
}

export function* watchChangeLeftSidebarTheme(): Generator {
  yield takeEvery(CHANGE_SIDEBAR_THEME, changeLeftSidebarTheme)
}

export function* watchChangeLeftSidebarThemeImage(): Generator {
  yield takeEvery(CHANGE_SIDEBAR_THEME_IMAGE, changeLeftSidebarThemeImage)
}

export function* watchChangeLeftSidebarType(): Generator {
  yield takeEvery(CHANGE_SIDEBAR_TYPE, changeLeftSidebarType)
}

export function* watchChangeTopbarTheme(): Generator {
  yield takeEvery(CHANGE_TOPBAR_THEME, changeTopbarTheme)
}

export function* watchShowRightSidebar(): Generator {
  yield takeEvery(SHOW_RIGHT_SIDEBAR, showRightSidebar)
}

export function* watchLoadCatalogos(): Generator {
  yield takeEvery(SET_IS_AUTHENTICATED, loadCatalogos)
}

function* LayoutSaga(): Generator {
  yield all([
    fork(watchChangeLayoutType),
    fork(watchChangeLayoutWidth),
    fork(watchChangeLeftSidebarTheme),
    fork(watchChangeLeftSidebarThemeImage),
    fork(watchChangeLeftSidebarType),
    fork(watchShowRightSidebar),
    fork(watchChangeTopbarTheme),
    fork(watchLoadCatalogos),
  ])
}

export default LayoutSaga
